import { useEffect, useState } from 'react'
import { api } from './api.ts'
import { daSchermataHome, nellAppCidis } from './app-nativa.ts'
import type { Io } from './api.ts'

/**
 * Inviti a installare l'app per il telefono (1.30.0): la riga sopra la pagina (AvvisoAppTelefono.tsx) e il
 * banner del cruscotto (BannerAppTelefono.tsx). Qui quello che hanno in comune: quando non servono e il
 * «più tardi» ricordato nel browser, per utenza (i computer delle sedi sono condivisi).
 */

/**
 * Telefoni connessi dell'utente (521), letti una volta per utenza e per caricamento della pagina. I computer
 * ricordati (531) stanno nello stesso elenco e non contano: l'app sul telefono non ce l'hanno.
 */
const connessi = new Map<string, Promise<boolean>>()

function haTelefonoConnesso(utenteId: string): Promise<boolean> {
  let p = connessi.get(utenteId)
  if (!p) {
    p = api.get<{ tipo: string }[]>('/auth/telefoni').then((t) => t.some((x) => x.tipo !== 'computer'))
      .catch(() => false)
    connessi.set(utenteId, p)
  }
  return p
}

/**
 * L'invito serve? No dentro l'app, nella web app aperta dalla schermata Home, impersonando un altro
 * utente (524), e a chi ha gia' un telefono connesso: l'app ce l'ha. Null finche' non si sa.
 */
export function useInvitoAppServe(io: Io | null): boolean | null {
  const escluso = !io || !!io.impersonazione || nellAppCidis() || daSchermataHome()
  const [connesso, setConnesso] = useState<boolean | null>(null)
  useEffect(() => {
    if (escluso || !io) return
    let vivo = true
    void haTelefonoConnesso(io.id).then((c) => { if (vivo) setConnesso(c) })
    return () => { vivo = false }
  }, [escluso, io])
  if (escluso) return false
  return connesso === null ? null : !connesso
}

const chiave = (dove: string, utente: string) => `cidis.app-telefono-${dove}.${utente}`

export function rimandato(dove: 'piu-tardi' | 'cruscotto', utente: string): boolean {
  try {
    return Number(window.localStorage.getItem(chiave(dove, utente))) > Date.now()
  } catch {
    return false
  }
}

export function rimanda(dove: 'piu-tardi' | 'cruscotto', utente: string, giorni: number) {
  try {
    window.localStorage.setItem(chiave(dove, utente), String(Date.now() + giorni * 24 * 60 * 60_000))
  } catch { /* archivio del browser pieno o vietato: l'invito resta chiuso fino al ricaricamento */ }
}

/** Il riquadro del profilo, da cui si apre tutto: dal computer e' l'indirizzo che il codice QR porta sul telefono. */
export const indirizzoIstruzioni = (io: Io) =>
  `${io.indirizzi?.gestionale ?? window.location.origin}/profilo#app-telefono`
